export default "__VITE_ASSET__a6852c65__"